export const API_KEY = process.env.API_KEY!;
export const API_KEY_STAGING = process.env.API_KEY_STAGING!;
export const PAYMASTER_POLICY_ID = process.env.PAYMASTER_POLICY_ID!;
export const PAYMASTER_POLICY_ID_STAGING =
  process.env.PAYMASTER_POLICY_ID_STAGING!;
export const UNDEPLOYED_OWNER_MNEMONIC = process.env.UNDEPLOYED_OWNER_MNEMONIC!;
export const LIGHT_ACCOUNT_OWNER_MNEMONIC =
  process.env.LIGHT_ACCOUNT_OWNER_MNEMONIC!;
